module.exports = __webpack_public_path__ + "static/media/image-card-1.6fe9bba1.png";